import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Header, main column and side column while the event loads (P16). */
const EventDetailSkeleton = () => (
  <Stack gap={3} aria-busy="true">
    <Skeleton variant="text" width={120} />
    <Skeleton variant="text" width="45%" height={40} />
    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' } }}>
      <Skeleton variant="rounded" height={420} />
      <Stack gap={3}>
        <Skeleton variant="rounded" height={160} />
        <Skeleton variant="rounded" height={180} />
      </Stack>
    </Box>
  </Stack>
);

export default EventDetailSkeleton;
